import { createAsyncThunk } from '@reduxjs/toolkit';
import * as shopMonitorIpsApi from '../../api/shopMonitorIpsApi';

export const getAllCompanyShopMonitorIPs = createAsyncThunk('getAllCompanyShopMonitorIPs', async (data) => {
    const res = await shopMonitorIpsApi.getAllCompanyShopMonitorIPs({ data: data });
    return res.data;
});

export const deleteCompanyShopMonitorIPs = createAsyncThunk('deleteCompanyShopMonitorIPs', async (data) => {
    const res = await shopMonitorIpsApi.deleteCompanyShopMonitorIPs({ data: data });
    return res.data;
});

export const checkValidIpAddress = createAsyncThunk('checkValidIpAddress', async (data) => {
    const res = await shopMonitorIpsApi.checkValidIpAddress({ data: data });
    return res.data;
}); 
